import { FC } from "react";
import styled from "styled-components";
import { SERVICE_UNAVAILABLE_MESSAGE } from "../../helpers/serviceUnavailable";

const StyledServiceUnavailable = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 60px 20px;
`;

const StyledTitle = styled.p`
  font-size: 24px;
  color: #000000;
  margin-bottom: 12px;
  line-height: 27px;
`;

const StyledMessage = styled.p`
  font-size: 16px;
  color: #000000;
  margin: 0;
  line-height: 27px;
`;

const ServiceUnavailable: FC = (): JSX.Element => {
  return (
    <StyledServiceUnavailable>
      <StyledTitle>We'll be right back</StyledTitle>
      <StyledMessage>{SERVICE_UNAVAILABLE_MESSAGE}</StyledMessage>
    </StyledServiceUnavailable>
  );
};

export default ServiceUnavailable;
